import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardProps,
  styled,
} from "@mui/material";
import { BrokenImage } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { useUrlSearch } from "hooks/filterHooks";

import { LayerSet } from "types/types";

import { Image } from "components/img/Image";
import { StyledMarkdown } from "components/layout/StyledMarkdown";

interface Props extends CardProps {
  layerSet: LayerSet;
  selectLayerSet: (id: number) => void;
}
export function LayerSetItem(props: Props) {
  const { layerSet, selectLayerSet, ...cardProps } = props;
  const { t } = useTranslation();
  const { search } = useUrlSearch();

  function generatePreviewUrl(layerSet: LayerSet) {
    const defaultLayer = layerSet.layerList.find(
      (layer) => layer.defaultSelection
    );
    const [firstLayer] = layerSet.layerList;

    const selectedLayerPreview = defaultLayer
      ? defaultLayer.geoserverLayer
      : firstLayer.geoserverLayer;

    return `/geoserver/wms/reflect?layers=${selectedLayerPreview}&height=100`;
  }

  function highlightSearch(text: string) {
    if (search) {
      const regex = new RegExp(search, "gi");
      const highlightedText = text.replace(regex, (match) => `***${match}***`);
      return highlightedText;
    }
    return text;
  }

  const layerSetDescription = highlightSearch(layerSet.description);

  return (
    <StyledCard elevation={0} {...cardProps}>
      <CardHeader title={layerSet.name} />
      <Image
        defaultIcon={<BrokenImage fontSize="large" />}
        height={100}
        src={generatePreviewUrl(layerSet)}
      />
      <CardContent>
        {/* <Typography variant="body2" color="text.secondary"> */}
        <StyledMarkdown content={layerSetDescription} />

        {/* <HighlightText text={layerSet.description} highlight={search} /> */}
        {/* </Typography> */}
      </CardContent>
      <CardActions disableSpacing>
        <Button
          variant="green-contained"
          onClick={() => selectLayerSet(layerSet.id)}
        >
          {t("label.viewMore")}
        </Button>
      </CardActions>
    </StyledCard>
  );
}

const StyledCard = styled(Card)`
  flex: 1 1 0px;
  min-width: 250px;
  max-width: 250px;
  height: 450px;
  min-height: 0;
  .MuiCardHeader-root {
    max-height: 50px;
    height: 100%;
    padding: 0;
    .MuiCardHeader-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
    }
    .MuiCardHeader-title {
      font-size: 13px;
      font-weight: 600;
    }
  }
  display: flex;
  flex-direction: column;
  .MuiCardContent-root {
    padding: 0;
    overflow: auto;
    height: 100%;
    margin-top: ${({ theme }) => theme.spacing(1)};
  }

  .MuiCardActions-root {
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
    height: 50px;
    padding: 0;
    padding-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;
